import { Tabs } from "antd";
import ChangeSimCard from "./ChangeSim/ChangeSimCard";
import Charge from "./Charge/Charge";
import Packages from "./Packages/Packages";

const HistoryAction = ({ purchase }) => {
	return (
		<>
			<Tabs
				className="tab-wallet"
				items={[
					{
						key: "profile_info",
						label: "شارژ",
						children: <Charge purchase={purchase} />,
					},
					{
						key: "history_purchase",
						label: "بسته",
						children: <Packages purchase={purchase} />,
					},
					{
						key: "leftover",
						label: "تعویض سیم‌کارت",
						children: <ChangeSimCard purchase={purchase} />,
					},
				]}
			/>
		</>
	);
};

export default HistoryAction;
